export default __webpack_public_path__ + "static/inventors-1f9d7a23f3164b3f127a223e600d3fa6.png";